export * from './auth-tenant-selection-failed.message';
export * from './auth-tenant-selection-failed-message-template.component';
